import Workspace from "../../../core/internal/workspace/Workspace"
import { InAppMessage } from "../../../core/internal/model/model"
import { TrackEvent } from "../../../core/internal/event/UserEvent"
import { InAppMessageEventTriggerRuleMatcher } from "./InAppMessageEventTriggerMatcher"

export class InAppMessageEventMatcher {
  constructor(private readonly ruleMatcher: InAppMessageEventTriggerRuleMatcher) {}

  matches(workspace: Workspace, inAppMessage: InAppMessage, event: TrackEvent): boolean {
    return this.ruleMatcher.matches(workspace, inAppMessage, event)
  }
}
